/**
 * Auditor's Report — auditor signature block.
 *
 * Two-column (`.doc-sign-block`): firm / partner credentials on the left,
 * place and date of report on the right. Shared by the Main Report and both
 * annexures (each statutory document carries the signature of even date).
 */
import { ph } from './companyTypes';

export function renderSignature(config = {}) {
  const firm = ph(config.firmName, '[Name of the Audit Firm]');
  const frn = ph(config.frn, '[FRN]');
  const partner = ph(config.partnerName, '[Engagement Partner Name]');
  const memNo = ph(config.membershipNo, '[Membership No.]');
  const udin = ph(config.udin, '[UDIN]');
  const place = ph(config.place, '[Place]');
  const reportDate = ph(config.reportDate, '[Date]');

  return `<div class="doc-sign-block">
  <div>
    <div><strong>For ${firm}</strong></div>
    <div>Chartered Accountants</div>
    <div>Firm Registration No.: ${frn}</div>
    <div class="doc-sign-line"></div>
    <div class="doc-sign-name">${partner}</div>
    <div class="doc-sign-desig">Partner</div>
    <div class="doc-sign-din">Membership No.: ${memNo}</div>
    <div class="doc-sign-din">UDIN: ${udin}</div>
  </div>
  <div style="text-align:right">
    <div>Place: ${place}</div>
    <div>Date: ${reportDate}</div>
  </div>
</div>`;
}
